

















import { Vue, Component, Prop } from 'vue-property-decorator';
import LessonStateButton from '../ui/LessonStateButton.vue';
import { routeHelper } from '../../../utils/routeHelper';
import { getTeacherSuffixInSession } from '../../../utils/building_trans';

@Component({ components: { LessonStateButton } })
export default class LessonTitleSection extends Vue {
  @Prop()
  teacherNickname!: string;
  @Prop()
  teacherUserId!: string;
  @Prop()
  subject!: string;
  @Prop()
  start!: string;
  @Prop()
  end!: string;
  @Prop()
  number!: number;
  @Prop()
  all!: number;
  @Prop({ default: 'dashboard' })
  type!: 'dashboard' | 'state';

  gotoLessonState() {
    // routeHelper(this, 'StudentLessonStateCalendarPage', { teacher_id: this.teacherUserId });
    routeHelper(this, 'StudentLessonStatePage', { teacher_id: this.teacherUserId });
  }

  get teacherSuffix() {
    return getTeacherSuffixInSession();
  }
}
